// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1OuyA","productName":"Table_productName__35vrH"};